import React from 'react';
import type { JobType as NumericJobType } from '../../../app/ApiGen';
import { JobType } from '../../../app/enums';
import { SelectableFilters, truncateAppliedFilters } from './SelectableFilters';
import type { FilterComponentProps } from './types';

type JobTypeFilterValues = Record<`${NumericJobType}`, boolean>;

const defaultFilters: JobTypeFilterValues = { 0: false };

export const HumanReadableJobType: Record<NumericJobType, string> = {
  [JobType.ResidentialInstall]: 'Residential Install',
};

function renderValues(value: [string, boolean][]): string {
  return truncateAppliedFilters(
    value.flatMap(([filterKey, filterApplied]) => {
      if (!filterApplied) return [];
      const jobTypeKey = parseInt(filterKey, 10) as NumericJobType;
      return [HumanReadableJobType[jobTypeKey]];
    }),
  );
}

export const JobTypeFilters: React.FC<FilterComponentProps> = ({ columnDef, onFilterChanged }) => (
  <SelectableFilters<NumericJobType, JobTypeFilterValues>
    columnDef={columnDef}
    defaultFilters={defaultFilters}
    onFilterChanged={onFilterChanged}
    options={Object.entries(HumanReadableJobType)}
    renderValues={renderValues}
  />
);
